import { DefaultState } from '@src/redux/types'

import {
  PFC_APPLICATION_EDIT,
  PFC_APPLICATION_FORM_ALL,
  PFC_APPLICATION_FORM_CURRENT,
  PFC_APPLICATION_FORM_FIELD_BATCH,
  PFC_APPLICATION_LIST,
  PFC_PAYMENT_ALL,
  PFC_PAYMENT_CONFIRM,
  PFC_PAYMENT_CREATE,
  PFC_PAYMENT_LIST,
  PFC_PAYMENT_PRINCIPAL,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [PFC_APPLICATION_EDIT]: DefaultState<`${typeof API.PFC_APPLICATION_EDIT}`, 'get'>
  [PFC_APPLICATION_LIST]: DefaultState<`${typeof API.PFC_APPLICATION}`, 'get'>
  [PFC_APPLICATION_FORM_ALL]: DefaultState<`${typeof API.PFC_APPLICATION_FORM_ALL}`, 'get'>
  [PFC_APPLICATION_FORM_CURRENT]: DefaultState<`${typeof API.PFC_APPLICATION_FORM_CURRENT}`, 'get'>
  [PFC_APPLICATION_FORM_FIELD_BATCH]: DefaultState<`${typeof API.PFC_APPLICATION_FORM_FIELD_BATCH}{id}`, 'get'>
  [PFC_PAYMENT_ALL]: DefaultState<`${typeof API.PFC_PAYMENT_ALL}`, 'get'>
  [PFC_PAYMENT_LIST]: DefaultState<`${typeof API.PFC_PAYMENT_LIST}`, 'get'>
  [PFC_PAYMENT_PRINCIPAL]: DefaultState<`${typeof API.PFC_PAYMENT_PRINCIPAL}`, 'get'>
  [PFC_PAYMENT_CREATE]: DefaultState<`${typeof API.PFC_PAYMENT_CREATE}`, 'post'>
  [PFC_PAYMENT_CONFIRM]: DefaultState<`${typeof API.PFC_PAYMENT_CONFIRM}{id}`, 'put'>
} = () => ({
  [PFC_APPLICATION_EDIT]: defaultState(),
  [PFC_APPLICATION_LIST]: defaultState(),
  [PFC_APPLICATION_FORM_ALL]: defaultState(),
  [PFC_APPLICATION_FORM_CURRENT]: defaultState(),
  [PFC_APPLICATION_FORM_FIELD_BATCH]: defaultState(),
  [PFC_PAYMENT_ALL]: defaultState(),
  [PFC_PAYMENT_CONFIRM]: defaultState(),
  [PFC_PAYMENT_CREATE]: defaultState(),
  [PFC_PAYMENT_LIST]: defaultState(),
  [PFC_PAYMENT_PRINCIPAL]: defaultState(),
})
